import { Chip, Tooltip, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { DeviceGroup } from 'utils/Lock/Lock';

interface Props {
  deviceGroups: DeviceGroup[];
}

const getHiddenDeviceGroupsTooltip = (deviceGroups: DeviceGroup[], translation: Translation): string =>
  translation.assigned_through_device_groups_list.replace(
    '{{names}}',
    deviceGroups.map((deviceGroup) => deviceGroup.name).join(', ')
  );

const AssignedViaDeviceGroupChip: React.FC<Props> = ({ deviceGroups }) => {
  const { translation } = useTranslation();
  const [firstDeviceGroup, ...otherDeviceGroups] = deviceGroups;

  return (
    <>
      <Tooltip title={translation.assigned_via_device_group} placement="top">
        <Chip
          size="small"
          variant="filled"
          label={<Typography variant="caption">{firstDeviceGroup.name}</Typography>}
        />
      </Tooltip>
      {otherDeviceGroups.length > 0 && (
        <Tooltip title={getHiddenDeviceGroupsTooltip(otherDeviceGroups, translation)} placement="top">
          <Chip
            size="small"
            variant="filled"
            label={<Typography variant="caption">{`+${otherDeviceGroups.length}`}</Typography>}
          />
        </Tooltip>
      )}
    </>
  );
};

export default AssignedViaDeviceGroupChip;
